import { type IContentLoaderProps } from './ContentLoaderTypes';
import Svg from './Svg';

type RectangleLoaderProps = {
	height?: React.CSSProperties['height'];
	width?: React.CSSProperties['width'];
	rx?: number;
	ry?: number;
	x?: number;
	y?: number;
};

export const RectangleLoader = ({ height = '100%', width = '100%', rx = 4, ry = 4, x = 0, y = 0 }: RectangleLoaderProps) => {
	return <rect x={x} y={y} rx={rx} ry={ry} width={width} height={height} />;
};

type ContentLoaderProps =
| ({
	fullWidth: true;
	height: number;
	width?: never;
} & IContentLoaderProps)
| ({
	fullWidth?: false;
	height: number;
	width: number;
} & IContentLoaderProps);

export const ContentLoader = ({ fullWidth, height, width, ...props }: ContentLoaderProps) => {
	return (
		<Svg
			backgroundColor="#E5EBEC"
			foregroundColor="#CCD7D9"
			speed={2}
			// This check is here to make sure the SVG scales properly when width is 100% or when it is fixed.
			viewBox={fullWidth ? undefined : `0 0 ${width} ${height}`}
			width={fullWidth ? '100%' : width}
			height={height}
			preserveAspectRatio={fullWidth ? 'none' : 'xMidYMid meet'}
			{...props}
		/>
	);
};
